import React from 'react';
import Routes from './routes';
import '@scss/app.scss';

const App = () => <Routes />;

export default App;
